import React from 'react'
import { Box, Typography, Button, Tooltip, List, ListItem } from '@mui/material'
import { HelpOutline } from '@mui/icons-material'
import theme from '../../theme'
import { AspectRatio } from '../../../types/campaign'

interface Props {
  option: AspectRatio
  handleSelectUpload: (option: AspectRatio) => void
}

const CreativeOptionHeader = ({ option, handleSelectUpload }: Props) => {
  const tooltipContent = (option: AspectRatio) => (
    <Box
      sx={{
        padding: theme.space['16'],
        display: 'block'
      }}
    >
      <Typography
        variant="heading-1"
        sx={{
          fontWeight: 600,
          color: theme.palette['base-white'],
          textTransform: 'capitalize'
        }}
      >
        {`${option.orientation} Asset Guidelines`}
      </Typography>
      <List
        component="div"
        aria-labelledby="landscape-img-requirement"
        sx={{
          listStyleType: 'disc',
          paddingLeft: 0,

          '& .MuiListItem-root': {
            fontSize: theme.typography['body-8'].fontSize,
            color: theme.palette['base-white'],
            paddingLeft: 0,
            paddingBottom: 0,
            whiteSpace: 'nowrap'
          }
        }}
      >
        <ListItem sx={{ display: 'list-item' }}>
          {`Aspect ratio: ${option.ratio}`}
        </ListItem>
        <ListItem
          sx={{
            display: 'list-item',
            paddingBottom: 0
          }}
        >
          Supported file types: png, jpg, mp4
        </ListItem>
        <ListItem
          sx={{
            display: 'list-item'
          }}
        >
          Max video duration: {option.max_creative_duration_ms / 1000}s
        </ListItem>
        <ListItem
          sx={{
            display: 'list-item'
          }}
        >
          {`Minimum resolution: ${option.minimum_resolution.width} x ${option.minimum_resolution.height}`}
        </ListItem>

        <ListItem
          sx={{
            display: 'list-item'
          }}
        >
          Max file size: 50mb
        </ListItem>
      </List>
    </Box>
  )
  return (
    <Box key={option.ratio}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Box sx={{ display: 'flex', gap: theme.space['24'] }}>
          <Typography
            variant="body-11"
            sx={{ textTransform: 'capitalize', width: '120px' }}
          >
            {option.orientation}
          </Typography>
          <Typography
            variant="body-9"
            sx={{ color: theme.palette['sage-400'] }}
          >
            {`${option.minimum_resolution.width} x ${option.minimum_resolution.height}`}
          </Typography>
          <Tooltip
            title={tooltipContent(option)}
            componentsProps={{
              tooltip: {
                sx: {
                  position: 'absolute',
                  borderRadius: theme.borders['rounded-10'],
                  width: 'fit-content',
                  maxWidth: '800px',
                  overflowY: 'auto'
                }
              }
            }}
            placement="top-end"
            slotProps={{
              popper: {
                modifiers: [
                  {
                    name: 'offset',
                    options: {
                      offset: [10, 220]
                    }
                  }
                ]
              }
            }}
          >
            <HelpOutline
              fontSize="small"
              sx={{ color: theme.palette['sage-400'] }}
            />
          </Tooltip>
        </Box>
        <Button
          variant="contained"
          color="primary"
          sx={{
            width: '120px',
            height: '32px',
            borderRadius: theme.borders['rounded-8']
          }}
          onClick={() => handleSelectUpload(option)}
        >
          <Typography
            variant="ui-1"
            sx={{
              textTransform: 'uppercase'
            }}
          >
            Upload New
          </Typography>
        </Button>
      </Box>
    </Box>
  )
}

export default CreativeOptionHeader
